import React, { useRef, useState, useEffect } from "react";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import ReactECharts from "echarts-for-react";

//function reutilizables
import { fechaAExcelNumero, excelAFecha } from "../../functions/functions.js";

function EleventhGraph({ visible, dataExcel, openLoader, setOpenLoader }) {
  const chartRef = useRef(null);

  const [dataGrafica, setDataGrafica] = useState({
    fechas: [],
    oz_au_plan: [], //eje x
    acumulado_plan_oz_au: [], //eje y
    oz_au_real_ocm: [], //eje x
    acumuluado_real_oz_ocm: [], //eje y
  });

  /*filtra los registros por fecha y obtiene solos los registros que se van a ocupar
    para graficas */
  useEffect(() => {
    if (dataExcel.length > 0) {
      fetchExcel();
      setOpenLoader(false);
    }
  }, [dataExcel]);

  useEffect(() => {
    // Forzar resize cuando los datos cambian o cuando se hace visible
    if (chartRef.current && dataExcel.length > 0) {
      chartRef.current.getEchartsInstance().resize();
    }
  }, [dataExcel, visible]);

  const fetchExcel = async () => {
    try {
      //Filtramos por fecha del todo mes de febrero 2025
      let fechaInicio = fechaAExcelNumero(2025, 2, 1);
      let fechaFinal = fechaAExcelNumero(2025, 2, 28);

      let _fechas = [];
      let _oz_au_plan = []; //eje x
      let _acumulado_plan_oz_au = []; //eje y
      let _oz_au_real_ocm = []; //eje x
      let _acumuluado_real_oz_ocm = []; //eje y

      //filtra los registros por fecha y añade una columna nueva (fecha string)
      const _datosExcel = dataExcel
        .filter((row) => row[0] >= fechaInicio && row[0] <= fechaFinal)
        .map((row) => {
          _fechas.push(excelAFecha(row[0]));
          _oz_au_plan.push(row[11]);
          _acumulado_plan_oz_au.push(row[12]);
          _oz_au_real_ocm.push(row[23]);
          _acumuluado_real_oz_ocm.push(row[24]);
        });

      setDataGrafica({
        fechas: _fechas,
        oz_au_plan: _oz_au_plan,
        acumulado_plan_oz_au: _acumulado_plan_oz_au,
        oz_au_real_ocm: _oz_au_real_ocm,
        acumuluado_real_oz_ocm: _acumuluado_real_oz_ocm,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: function (opt) {
            const categorias = opt.xAxis[0].data;

            const seriesMap = {};
            opt.series.forEach((s) => {
              seriesMap[s.name] = s.data;
            });

            // Encabezados personalizados
            const headers = [
              "Fecha",
              "Oz Au_Plan",
              "Oz Au_Real_OCM",
              "Acumulado Plan Oz Au",
              "Acumulado Real Oz Au OCM",
            ];

            let table = `
          <table style="width:100%;border-collapse:collapse;text-align:center;" border="1">
            <thead>
              <tr>
                ${headers
                  .map(
                    (h) =>
                      `<th style="padding:4px;background:#f2f2f2">${h}</th>`
                  )
                  .join("")}
              </tr>
            </thead>
            <tbody>
        `;

            // Recorrer todas las fechas
            for (let i = 0; i < categorias.length; i++) {
              table += "<tr>";
              table += `<td>${categorias[i]}</td>`;
              table += `<td>${format(seriesMap["Oz Au_Plan"]?.[i])}</td>`;
              table += `<td>${format(seriesMap["Oz Au_Real_OCM"]?.[i])}</td>`;
              table += `<td>${format(
                seriesMap["Acumulado Plan Oz Au"]?.[i]
              )}</td>`;
              table += `<td>${format(
                seriesMap["Acumulado Real Oz Au OCM"]?.[i]
              )}</td>`;
              table += "</tr>";
            }

            table += "</tbody></table>";
            return table;

            // Función de formato segura
            function format(val) {
              return isNaN(val) || val === null || val === ""
                ? "---"
                : parseFloat(val).toFixed(2);
            }
          },
        },

        //otros tipos de graficas
        magicType: {
          show: true,
          type: ["line", "bar"],
          title: {
            line: "Cambiar a Línea",
            bar: "Cambiar a Barra",
          },
        },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    //leyendas y data
    legend: {
      data: [
        "Oz Au_Plan",
        "Oz Au_Real_OCM",
        "Acumulado Plan Oz Au",
        "Acumulado Real Oz Au OCM",
      ],
    },
    xAxis: [
      {
        type: "category",
        data: dataGrafica.fechas,
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "AUEQ ONZAS",
        min: 0,
        max: 600,
        interval: 100,
        axisLabel: {
          formatter: "{value}",
        },
      },
      {
        type: "value",
        name: "Acumulado Plan OZ AU",
        min: 0,
        max: 7000,
        interval: 1000,
        axisLabel: {
          formatter: "{value}",
        },
      },
    ],
    series: [
      {
        name: "Oz Au_Plan",
        type: "bar",
        itemStyle: {
          color: "#99abd9",
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.oz_au_plan,
      },
      {
        name: "Oz Au_Real_OCM",
        type: "bar",
        itemStyle: {
          color: "#f5b498",
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.oz_au_real_ocm,
      },
      {
        name: "Acumulado Plan Oz Au",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#203864",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.acumulado_plan_oz_au,
      },
      {
        name: "Acumulado Real Oz Au OCM",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#ff0000",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.acumuluado_real_oz_ocm,
      },
    ],
  };

  // Manejar evento de restauración
  const onEvents = {
    restore: () => {
      // Reaplica el gráfico original
      chartRef.current.getEchartsInstance().setOption(option, true);
    },
  };

  return (
    <div className="p-4 rounded-lg shadow-lg  bg-blanco border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div style={{ width: "100%", height: "70vh" }}>
        <ReactECharts
          ref={chartRef}
          option={option}
          onEvents={onEvents}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
}

export default EleventhGraph;
